
































































import { computed, defineComponent, useContext } from "@nuxtjs/composition-api";
import { usePageStore } from "~/stores/page";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";

import { decodeUid, isMobile } from "~/helpers";
import LazyComponent from "v-lazy-component/vue2";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import { useLayoutsStore } from "~/stores/extensionApi";

const LayoutService = () => import("~/components/homePage/LayoutService.vue");
const BannerSlider = () => import("~/components/homePage/BannerSlider.vue");
const PromotionOnOff = () => import("~/components/homePage/PromotionOnOff.vue");
const PromotionFilter = () =>
  import("~/components/homePage/PromotionFilter.vue");
const BannerCollection = () =>
  import("~/components/homePage/BannerCollection.vue");
const CollectVoucher = () => import("~/components/vouchers/CollectVoucher.vue");
const ProductCate = () => import("~/components/homePage/ProductCate.vue");
const BannerImage = () => import("~/components/homePage/BannerImage.vue");
const FlashSale = () => import("~/components/homePage/FlashSale.vue");
const BlogNews = () => import("~/components/homePage/BlogNews.vue");
const ThreeColumnBanners = () =>
  import("~/components/homePage/ThreeColumnBanners.vue");
const BannerInstagram = () =>
  import("~/components/homePage/BannerInstagram.vue");
const ProductTabsCate = () =>
  import("~/components/homePage/ProductTabsCate.vue");
const BannerText = () => import("~/components/homePage/BannerText.vue");
const NewProduct = () => import("~/components/homePage/NewProduct.vue");
const CategoryBreadcrumbs = () => import("~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue");
const BannerCanifaS = () => import("~/components/homePage/BannerCanifaS.vue");
const CanifasBlog = () => import("~/components/homePage/CanifasBlog.vue");
import HeaderS from "./landingPages/canifas/HeaderS.vue";
import CanifaS from "./landingPages/canifas/CanifaS.vue";

export default defineComponent({
  name: "CategoryLandingPage",
  components: {
    LazyComponent,
    SkeletonLoader,
    LandingFilterPage: () => import("./landingPages/LandingFilterPage.vue"),
    BannerImage,
    ProductCate,
    NewProduct,
    ProductTabsCate,
    BannerText,
    FlashSale,
    LayoutService,
    BannerSlider,
    BannerCollection,
    CollectVoucher,
    ThreeColumnBanners,
    PromotionOnOff,
    PromotionFilter,
    BlogNews,
    BannerInstagram,
    CategoryBreadcrumbs,
    HeaderS,
    CanifaS,
    BannerCanifaS,
    CanifasBlog
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
  },

  setup(props) {
    const { routeData } = usePageStore();
    const { app } = useContext();
    const categoryId = decodeUid(props.uid);
    const layoutsStore = useLayoutsStore();
    const getLayouts = computed(() => layoutsStore.getLayouts[categoryId]);

    const filteredLayouts = computed(() => {
      if (!getLayouts.value) return [];
      const isMobile = app && app.$device && app.$device.isMobile;
      return getLayouts.value.filter((layout) => {
        if (!layout.store_codes) return false;

        if (
          layout.store_codes.includes("vi") &&
          layout.store_codes.includes("mobile")
        ) {
          return true;
        }

        return isMobile
          ? layout.store_codes.includes("mobile")
          : layout.store_codes.includes("vi");
      });
    });

    const { activeCategoryById } = useTraverseCategory();
    const activeCategoryByUid = computed(() => {
      return activeCategoryById(decodeUid(routeData?.uid));
    });

    return {
      routeData,
      getLayouts,
      filteredLayouts,
      activeCategoryName: computed(() => activeCategoryByUid.value?.name ?? ""),
      categoryId,
    };
  },
});
